import React from "react";

const ArrowDownIcon = () => {
  return (
      <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="Vector 146" d="M6.48047 0.741211L6.48047 13.7788M6.48047 13.7788L11.9631 8.29611M6.48047 13.7788L0.992672 8.29097" stroke="#DA291C" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
  );  
};

export default ArrowDownIcon;